export default __webpack_public_path__ + "static/media/NZ-Driver-Back.fa7e7dae.png";